import React from "react";
import {MobileMenuItemContainerBox} from "../boxes/mobile-menu-item-container.box";
import {MobileMenuItemLinkBox} from "../boxes/mobile-menu-item-link.box";
import {AppIdentifiers, AreaType} from "@sparkware/uc-sdk-core";
import { GenericSideMenuItemIconBox } from "../../side-menu-rework/side-menu-items/boxes/link/generic/generic-side-menu-item-icon.box";
import {ComponentServicesPick} from "../../../services/component-services-pick";
import {observer} from "mobx-react";
import {useServices} from "../../../react-hooks/use-services.hook";
import {withServices} from "../../../react-hooks/with-services";

interface MobileHelpCenterMenuItemComponentProps extends ComponentServicesPick<'sideMenu'> {
    
}

export const ComponentBody: React.FC<MobileHelpCenterMenuItemComponentProps> = observer((props) => {
    const services = useServices();
    const _mobileHelpButtonHandler = async () => {
        services.analytics.sendOrbitUserFlowEvent("Navigation",'Header', 'Help');
        if(services.configuration.servicesConfigs.AppLauncher.apps.CR_HELP_CENTER.enabled) {
            await props.sideMenu.closeMobileMenu();
        } else {
            (await services.userMenu).closeMenu();
        }

        await (await services.appLauncher).openHelpCenter({
            businessCorrelationID: services.tools.getGuid(),
            channel: {
                area: AreaType.HamburgerMenu,
                element: AppIdentifiers.CRHelpCenter,
                source: AppIdentifiers.CasinoClient
            }
        });
    }

    const _renderText = () => {
        if (services.configuration.servicesConfigs.AppLauncher.apps.CR_HELP_CENTER.enabled) {
            return services.translation.translate("HELP_CENTER")
        } else {
            return services.translation.translate("HELP")
        }
    }

    const HelpIcon = services.theme.currentTheme.icons.helpCenterIcon;
    return (
        <MobileMenuItemContainerBox className="cy-menu-item">
            <GenericSideMenuItemIconBox>
                <HelpIcon size={2} />
            </GenericSideMenuItemIconBox>
            <MobileMenuItemLinkBox className="cy-help-mobile-link" onClick={_mobileHelpButtonHandler}>
                {_renderText()}
            </MobileMenuItemLinkBox>
        </MobileMenuItemContainerBox>
    );
});

export const MobileHelpCenterMenuItemComponent = withServices(ComponentBody, ['sideMenu']);